import { useClientStore } from "@/store/client";
import { useMagasinStore } from "@/store/magasin";
import apiDriveListe from "@/services/http/api-drive/client/listeDeCourse";
import apiDriveMagasin from "@/services/http/api-drive/magasin";
import { states } from "@/components/molecules/mixins/form.mixin";

export const usePageMonCompte = (magasinSelectorPopinRef) => {

  const app = useNuxtApp()
  const clientStore = useClientStore();
  const magasinStore = useMagasinStore();

  const { client, isPro, abonnements } = storeToRefs(clientStore);
  const { id: magasinId, isEligibleAliasPaiement, isFidCarrefour } = storeToRefs(magasinStore);

  const { update } = clientStore;

  const listesDeCourse = ref([])
  const listesDeCourseCount = ref(0)
  const listesDeCourseLoading = ref(false)
  const magasin = ref(null)
  const magasinLoading = ref(false)
  const state = ref(null)
  const error = ref(null)

  const getListesDeCourse = async () => {
    listesDeCourseLoading.value = true;
    try {
      const ldc = await app.$apiDrive
        .use(apiDriveListe)
        .listeDeCourses({
          magasin_id: magasinId.value
        });
      listesDeCourseCount.value = ldc.length;
      listesDeCourse.value = ldc.slice(0, 4);
    } finally {
      listesDeCourseLoading.value = false;
    }
  }
  const getMagasin = async () => {
    magasinLoading.value = true;
    try {
      const mag = await app.$apiDrive
        .use(apiDriveMagasin)
        .magasin(client.value.attributes.id_magasin);
      magasin.value = mag.data;
    } finally {
      magasinLoading.value = false;
    }
  }
  const changeMagasinRattachement = async (magasinId) => {
    try {
      state.value = states.LOADING;
      await update({ id_magasin: magasinId });
      state.value = states.SUCCESS;
      magasinSelectorPopinRef.value.hide();
      await getMagasin();
    } catch (error) {
      state.value = states.ERROR;
      error.value = error;
    }
  }

  return {
    isFidCarrefour,
    client,
    isPro,
    abonnements,
    magasinId,
    isEligibleAliasPaiement,
    listesDeCourse,
    listesDeCourseCount,
    listesDeCourseLoading,
    magasin,
    magasinLoading,
    state,
    error,
    getListesDeCourse,
    getMagasin,
    changeMagasinRattachement,
  }
}